/**
 * Created by wangjianwen on 2017/10/16.
 */
export default {
    setHeaderState: ({commit}, param) => commit('setHeaderState', {headerState: param}),
    setToken: ({commit}, param) => commit('setToken', {token: param}),
    setJwtToken: ({commit}, param) => commit('setJwtToken', {jwtToken: param}),
    setCurrentUser: ({commit}, param) => commit('setCurrentUser', {userInfo: param}),
    setPageInfo: ({commit}, param) => commit('setPageInfo', {pageInfo: param}),
    setFooterInfo: ({commit}, param) => commit('setFooterInfo', {footerInfo: param}),
    setUserType: ({commit}, param) => commit('setUserType', {userType: param}),
    setCertType:({commit}, param) => commit('setCertType', {certType: param}),
    setProjectToken: ({commit}, param) => commit('setProjectToken', {projectToken: param}),
}